<template>
  <AuthLayout>
    <form @submit.prevent="save">
      <div class="login-form__title">Cambiar contraseña</div>
      <div v-if="required" class="login-form__subtitle">Es tu primer ingreso. Para continuar, cambiá la contraseña temporal por una que solo vos conozcas.</div>
      <div v-else class="login-form__subtitle">Ingresá tu contraseña actual y elegí una nueva.</div>

      <div class="login-form__fields">
        <div>
          <label for="current-password" class="login-form__label">Contraseña actual</label>
          <input
            id="current-password"
            v-model="current_password"
            :type="show ? 'text' : 'password'"
            class="login-form__input"
            name="current_password"
            data-vv-as="contraseña actual"
            v-validate="'required'"
            autocomplete="current-password"
          />
          <span class="red--text login-form__field-error">{{ errors.first("current_password") }}</span>
        </div>

        <div>
          <label for="new-password" class="login-form__label">Contraseña nueva</label>
          <div class="login-form__password">
            <input
              id="new-password"
              ref="password"
              v-model="password"
              :type="show ? 'text' : 'password'"
              class="login-form__input"
              name="password"
              data-vv-as="contraseña nueva"
              v-validate="{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }"
              autocomplete="new-password"
            />
            <button type="button" class="login-form__toggle" :aria-label="show ? 'Ocultar contraseñas' : 'Mostrar contraseñas'" @click="show = !show">
              <v-icon small>{{ show ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
            </button>
          </div>
          <span class="red--text login-form__field-error">{{ errors.first("password") }}</span>
        </div>

        <div>
          <label for="password-confirmation" class="login-form__label">Repetir contraseña nueva</label>
          <input
            id="password-confirmation"
            v-model="password_confirmation"
            :type="show ? 'text' : 'password'"
            class="login-form__input"
            name="password_confirmation"
            data-vv-as="repetir contraseña"
            v-validate="'required|confirmed:password'"
            autocomplete="new-password"
          />
          <span class="red--text login-form__field-error">{{ errors.first("password_confirmation") }}</span>
        </div>

        <div class="login-form__hint">Al menos 8 caracteres, con letras y números.</div>

        <button type="submit" class="login-form__submit" :disabled="loading">{{ loading ? "Guardando..." : "Cambiar contraseña" }}</button>
      </div>

      <button type="button" class="login-form__link" @click="logout">{{ required ? "Cerrar sesión" : "Volver" }}</button>
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/AuthLayout.vue";
import { authService } from "@/libs/ws/authService";

// Cambio de contraseña. Es obligatorio en el primer ingreso con la contraseña temporal que puso RRHH.
export default {
  name: "ChangePassword",
  components: { AuthLayout },
  data: () => ({
    current_password: "",
    password: "",
    password_confirmation: "",
    show: false,
    loading: false,
  }),
  computed: {
    required() {
      return authService.mustChangePassword();
    },
  },
  methods: {
    async save() {
      if (this.loading || !(await this.$validator.validate())) return;

      this.loading = true;
      authService
        .change_password({
          current_password: this.current_password,
          password: this.password,
          password_confirmation: this.password_confirmation,
        })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            localStorage.setItem("must_change_password", "false");
            this.$router.push("/");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    logout() {
      if (!this.required) {
        this.$router.go(-1);
        return;
      }
      authService.logOut();
      this.$router.push("/login");
    },
  },
};
</script>
